<template>
  <form class="flex-column form-types" @submit.prevent="submit($event, 1)" ref="formElement">
    
    <div class="form-summary-context">
      シミュレーター結果をアトリエタマリに送信していただけます。確定ではございませんので、検討中の方もこちらからお気軽に送信してください。
      <!-- <b>シミュレーターオーダー特典として総額から5%割引いたします。（※デザインサンプル貸出の場合は適応されません）</b>割引後の金額は折り返しご案内します。-->
      <p>ご注文後にもデザインを変更することができます。</p>
    </div>
    <div class="flex justify-space-between row">
      <input-wrapper v-model="form.name.value" placeholder="山本博士"
                     :validation="form.name.required && invalids.includes('name')"
                     label-text="お名前（漢字）※必須" />
      <input-wrapper v-model="form.nameFurigana.value" placeholder="ヤマモトヒロシ"
                     :validation="form.nameFurigana.required && invalids.includes('nameFurigana')"
                     label-text="フリガナ ※必須" />
    </div>
    <div class="row flex justify-space-between divide">
      <input-wrapper v-model="form.partnerName.value" placeholder="田中陽子"
                     :validation="form.partnerName.required && invalids.includes('partnerName')"
                     label-text="パートナーのお名前（漢字）" />
      <input-wrapper v-model="form.partnerFurigana.value"
                     :validation="form.partnerFurigana.required && invalids.includes('partnerFurigana')"
                     placeholder="タナカヨウコ"
                     label-text="パートナー名フリガナ " />
    </div>

    <div class="flex justify-space-between row half">
      <input-wrapper v-model="form.postcode.value" placeholder="（例：5600123）"
                     :validation="form.postcode.required && invalids.includes('postcode')"
                     max-length="7"
                     :postcode="true"
                     label-text="郵便番号 ※必須" />

      <select-wrapper v-model="form.city.value"
                      :validation="form.city.required && invalids.includes('city')"
                      label-text="都道府県 ※必須" :options="cities"/>
    </div>
    <div class="row flex justify-space-between divide">
      <input-wrapper v-model="form.address.value" placeholder="番地..."
                     :validation="form.address.required && invalids.includes('address')"
                     label-text="ご住所 (番地、マンション名までご入力ください) ※必須" />
      <input-wrapper v-model="form.tel.value" type="tel" placeholder="（例：09012345678）"
                     :validation="form.tel.required && invalids.includes('tel')"
                     max-length="11"
                     label-text="電話番号 ※必須" />
    </div>

    <div class="row flex justify-space-between divide">
      <input-wrapper v-model="form.email.value" placeholder="（例：tamari@atelier-tamari.com）"
                     :validation="form.email.required && invalids.includes('email')"
                     type="email"
                     label-text="メールアドレス ※必須" />
      <input-wrapper v-model="form.email2.value" type="email" placeholder="（例：tamari@atelier-tamari.com）"
                     :validation="form.email2.required && invalids.includes('email2')"
                     :disabled="!form.email.value"
                     label-text="メールアドレス確認用 ※必須" />
    </div>

    <div class="flex-column justify-space-between row half enrollmentDate">
      <div class="flex align-center justify-space-between checkbox-container">
        <h5>入籍予定日</h5>
        <checkbox-wrapper label-text="未定"  v-model="form.enrollmentDate.value" />
      </div>
      <div class="flex select-container">
        <select-wrapper dynamicEmptyOption="年" v-model="form.enrollmentDate.year" :disabled="form.enrollmentDate.value" :options="years" :small-row="true"/>
        <select-wrapper dynamicEmptyOption="月" v-model="form.enrollmentDate.month" :disabled="form.enrollmentDate.value" :options="months" :small-row="true"/>
        <select-wrapper dynamicEmptyOption="日" v-model="form.enrollmentDate.day" :disabled="form.enrollmentDate.value" :options="days" :small-row="true"/>
      </div>
    </div>

    <div class="flex-column justify-space-between row half divide weddingDate">
      <div class="flex align-center justify-space-between checkbox-container">
        <h5>挙式予定日</h5>
        <checkbox-wrapper label-text="未定" v-model="form.weddingDate.value" />
      </div>
      <div class="flex select-container">
        <select-wrapper dynamicEmptyOption="年" v-model="form.weddingDate.year" :disabled="form.weddingDate.value" :options="years" />
        <select-wrapper dynamicEmptyOption="月" v-model="form.weddingDate.month" :disabled="form.weddingDate.value" :options="months" />
        <select-wrapper dynamicEmptyOption="日" v-model="form.weddingDate.day" :disabled="form.weddingDate.value" :options="days" />
      </div>
    </div>

    
    <div class="gaugeForm row half divide">
      <h5>貸出サイズゲージ </h5>
      <!-- <div><select-wrapper v-model="form.gauge.value"  :options="gauge" :validation="form.gauge.required && invalids.includes('gauge')"  dynamicEmptyOption="サイズ" style="width: 115px" /></div> -->
      <div class="summary-text">
        リング用サイズゲージを郵便にてお貸出しいたしております。サイズゲージは2週間でご返却ください
      </div>

      <div class="flex row half">
        <label for="gaugeCheck1" class="pointer">
          <span class="img block oval"></span>
          <span class="radio-wrapper flex align-center">
            <input type="radio" id="gaugeCheck1" v-model="form.gauge.check" value="必要"> 必要</span>
        </label>
        <label for="gaugeCheck2" class="pointer">
          <span class="img block oval"></span>
          <span class="radio-wrapper flex align-center">
            <input type="radio" id="gaugeCheck2" v-model="form.gauge.check" value="不要"> 不要</span>
        </label>
      </div>
    </div>

    <h5>リングケース</h5>
    <div class="flex justify-space-between box-container">
      <label for="box1" class="box1 pointer">
        <span class="img block oval"></span>
        <span class="radio-wrapper flex align-center">
          <input type="radio" id="box1" v-model="form.boxType.value" value="木のケース"> 木のケース</span>
        <span class="summary-text block">タモの無垢材で作った、日本の職人が仕上げている、とても良い作りのケースです</span>
      </label>
      <label for="box2" class="box2 pointer">
        <span class="img block oval"></span>
        <span class="radio-wrapper flex align-center">
          <input type="radio" id="box2" v-model="form.boxType.value" value="ヌメ革のケース"> ヌメ革のケース</span>
        <span class="summary-text block">手にしっくりと馴染みまむヌメ革の温かなケースです</span>
      </label>
    </div>

    <div class="flex justify-space-between box-container alone-box">
      <label class="pointer">
        <span class="radio-wrapper flex align-center"><input type="radio" v-model="form.boxType.value" value="ケースは検討中"> ケースは検討中</span>
      </label>
    </div>

    <!-- <div class="flex-column justify-space-between row half credit-card">
      <h3 class="flex justify-space-between">お支払い方法 <u class="pointer">お支払いについて</u></h3>
      <div class="button-wrapper">
        <button type="button" class="flex align-center justify-start rounded transition pointer"
                :class="{active:form.paymentType.value ==='クレジットカード'}"
                @click="changeActiveButton('クレジットカード', 'paymentType')">クレジットカード</button>
        <button type="button" class="flex align-center justify-start rounded transition pointer"
                :class="{active:form.paymentType.value ==='銀行振込'}"
                @click="changeActiveButton('銀行振込', 'paymentType')">銀行振込</button>
        <button type="button" class="flex align-center justify-start rounded transition pointer"
                :class="{active:form.paymentType.value ==='未定'}"
                @click="changeActiveButton('未定', 'paymentType')">未定</button>

        <p class="summary">※お支払いはデザイン決定後となります</p>
      </div>
    </div> -->

    <div class="flex-column justify-space-between row half delivery-date">
      <h3 class="flex justify-space-between">納期のご希望</h3>
      <div class="button-wrapper">
        <button type="button" class="flex align-center justify-start rounded transition pointer"
                :class="{active:form.deliveryDate.value ==='通常納期（2.5〜3ヶ月）'}"
                @click="changeActiveButton('通常納期（2.5〜3ヶ月）', 'deliveryDate')">通常納期（2.5〜3ヶ月）</button>
        <button type="button" class="flex align-center justify-start rounded transition pointer"
                :class="{active:form.deliveryDate.value ==='特急（通常納期で間に合わない場合はこちら）'}"
                @click="changeActiveButton('特急（通常納期で間に合わない場合はこちら）', 'deliveryDate')">特急（通常納期で間に合わない場合はこちら）</button>

        <p class="summary">※特急納期はデザインによって異なりますが、目安として5,000〜8,000円程度となっております。</p>
      </div>
    </div>

    <div class="contact">
      <h3 class="flex justify-space-between">お問い合わせ内容</h3>
      <p>デザインその他のご相談があればこちらにご記入ください。</p>
      <p>特急納期を選択の方は希望納期をこちらにご記入ください。</p>
      <textarea class="oval" v-model="form.comment.value"></textarea>
      <p class="policy"><a href="https://tamari.shop-pro.jp/?mode=privacy" class="pointer" target="_blank">プライバシーポリシー</a>に同意のうえ、「送信する」をクリックしてください。</p>
    </div>

    <div class="submit">
      <input type="submit" class="flex align-center justify-center submit-btn rounded transition pointer" value="送信する">
      <ul>
        <li>
          携帯・スマートフォンのキャリアメールアドレスでは、お客様が迷惑メール対策等でメールが届かない場合がございます。PCメールのご入力をしていただくか、以下のドメインを受信できるように設定してください。
          <span class="block pointer">atelier-tamari.com</span>
          万が一3日以上経過しても返信がない場合は、恐れ入りますが直接お電話ください。<br>
          Tel. 06-6585-0500
        </li>
      </ul>
    </div>

  </form>
</template>

<script>
import useFormHandler from "@/modules/moduleA/helpers/useFormHandler";
import InputWrapper from "@/modules/moduleA/components/forms/InputWrapper";
import SelectWrapper from "@/modules/moduleA/components/forms/SelectWrapper";
import CheckboxWrapper from "@/modules/moduleA/components/forms/CheckboxWrapper";
import {onMounted, computed, ref} from "vue";
export default {
  name: "FormType1",
  components: {CheckboxWrapper, SelectWrapper, InputWrapper},
  setup(){
    return {...useFormHandler()}
  }
}
</script>

<style scoped>
.form-types {
  width: 724px;
  margin: auto;
}
.form-types > .form-header {
  padding: 30px 0;
  background-color: white;
}
.form-types > .form-header h2.title {
  font-weight: 400;
  font-size: 1.6rem;
}
.form-types > .form-header h4.sub-title {
  font-weight: 400;
  font-size: 1rem;
}
.form-types > .form-summary-context {
  padding: 0 5px;
  font-size: .9rem;
  color: #5b5b5d;
  margin-bottom: 40px;
}
.form-types > .form-summary-context > b {
  font-size: .85rem;
  color: #22252f;
}
.form-types > .form-summary-context > p {
  margin-top: 10px;
}
.form-types > .summary-text {
  font-size: .9rem;
  margin: 30px 0;
  padding-left: 10px;
}

.form-types > .row {
  border-bottom: 1px solid #dcdde1;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.form-types > .row.half {
  width: 48%;
}
.form-types > .row.divide {
  border-bottom: 1px solid #dcdde1;
  padding-bottom: 10px;
  margin-bottom: 34px;
}
.form-types > .row > .checkbox-container {
  margin-bottom: 10px;
}
.form-types > .row > .checkbox-container > h5 {
  padding-left: 10px;
  font-weight: 400;
}

.form-types > .box-container {
  width: 352px;
}
.form-types > .box-container.alone-box {
  margin-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 14px;
  border-bottom: 1px solid #dcdde1;
}
.form-types > .box-container > label {
  width: 160px;
  height: auto;
}
.form-types > .box-container > label > span.img {
  width: 100%;
  border: 4px solid white;
  height: 160px;
  background-size: cover;
  background-position: center;
}
.form-types > .box-container > label.box1 > span.img {
  background-image: url("../../../assets/images/box1.jpg");
}
.form-types > .box-container > label.box2 > span.img {
  background-image: url("../../../assets/images/box2.jpg");
}
.form-types > .box-container > label > span.radio-wrapper {
  margin-top: 14px;
  padding-left: 10px;
}
.form-types > .box-container > label > span.radio-wrapper {
  margin-top: 14px;
  padding-left: 10px;
  font-size: .8rem;
}
.form-types > .box-container > label > span.radio-wrapper > input {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.form-types > .box-container > label > span.summary-text {
  font-size: .8rem;
  margin-top: 10px;
}
.form-types > .delivery-date,
.form-types > .credit-card {
  margin-top: 40px;
}
.form-types > .delivery-date {
  margin-top: 20px;
}
.form-types > .contact > h3,
.form-types > .delivery-date > h3,
.form-types > .credit-card > h3 {
  font-size: .85rem;
  font-weight: 400;
  padding-left: 10px;
}
.form-types > .delivery-date > h3 > u ,
.form-types > .credit-card > h3 > u {
  font-size: .75rem;
}
.form-types > .delivery-date > .button-wrapper,
.form-types > .credit-card > .button-wrapper {
  margin-top: 20px;
}
.form-types > .delivery-date > .button-wrapper > button,
.form-types > .credit-card > .button-wrapper > button {
  background: white;
  color: #000;
  border: 2px solid #c8c8c9;
  height: 40px;
  width: 100%;
  margin-bottom: 10px;
  padding-left: 20px;
}
.form-types > .delivery-date > .button-wrapper > button.active,
.form-types > .credit-card > .button-wrapper > button.active {
  background-color: #22252f;
  color: white;
  border-color: white;
}
.form-types > .delivery-date > .button-wrapper > button:last-child,
.form-types > .credit-card > .button-wrapper > button:last-child {
  margin-bottom: 0;
}
.form-types > .delivery-date > .button-wrapper > p.summary,
.form-types > .credit-card > .button-wrapper > p.summary {
  padding-left: 24px;
  font-size: .75rem;
}
.form-types > .contact {
  margin-top: 20px;
}
.form-types > .contact > h3 {
  margin-bottom: 20px;
}
.form-types > .contact > p {
  font-size: .75rem;
  padding-left: 10px;
}
.form-types > .contact > textarea {
  margin-top: 20px;
  border: 2px solid white;
  padding: 10px;
  font-size: .9rem;
  width: 100%;
  height: 200px;
  outline: 0;
}
.form-types > .contact > textarea:focus {
  border-color: #797979;
}
.form-types > .contact > p.policy {
  margin-top: 10px;
}
.form-types > .contact > p.policy > u {
  font-size: .85rem;
}
.form-types > .contact > p.policy > a {
  text-decoration: underline;
  color: #000;
}

.form-types > .submit > .submit-btn {
  height: 50px;
  border: 2px solid #5b5b5d;
  color: white;
  background-color: #5b5b5d;
  max-width: 352px;
  width: 100%;
  margin: 40px auto;
  font-size: 1rem;
}
.form-types > .submit > .submit-btn:hover {
  background-color: #22252f;
  border-color: white;
}
.form-types > .submit > ul {
  padding-left: 15px;
}
.form-types > .submit > ul > li {
  font-size: .8rem;
  color: #5b5b5d;
}
.form-types > .submit > ul > li > span {
  margin: 20px 0;
}

.form-types .gaugeForm {
  position: relative;
}
.form-types .gaugeForm .summary-text {
    font-size: .8rem;
    margin-top: 10px;
}
.form-types .gaugeForm label {
    width: 40%;
}
.form-types .gaugeForm label > span.radio-wrapper {
    margin-top: 14px;
    padding-left: 10px;
    font-size: .8rem;
}
.form-types .gaugeForm label > span.radio-wrapper > input {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}



@media screen and (max-width: 724px) {
  .form-types {
    width: 100%;
    padding: 0 10px;
  }
  .form-types > .row {
    flex-direction: column;
    align-items: center;
  }
  .form-types > .row.half {
    width: 100%;
  }
  .form-types > .row.half > .checkbox-container,
  .form-types > .row.half > .select-container,
  .form-types > .summary-text {
    width: 362px;
  }
  .form-types > .contact,
  .form-types > .submit,
  .form-types > .box-container,
  .form-types > .summary-text {
    margin-left: auto;
    margin-right: auto;
    width: 362px;
  }
  .form-types > .box-container.alone-box {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  .form-types > .box-container.alone-box > label {
    margin-left: auto;
    margin-right: auto;
    width: 362px;
  }

  .form-types .credit-card > .button-wrapper,
  .form-types .delivery-date > .button-wrapper {
    width: 362px;
  }
  .form-types > .row > .form-row  {
    width: 100%;
    max-width: 374px;
    min-width: 364px;
    margin-bottom: 10px;
  }
  .form-types .gaugeForm {
    align-items: initial;
  }
  
}
</style>
